/**
 * Available Message types
 */

export const MessageType = {
    SUCCESS: 'SUCCESS',
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
};

export const allMessageTypes = Object.keys(MessageType);
